import { CameraOutlined, PictureOutlined } from '@ant-design/icons';
import { Tag, Modal, Tabs, Alert } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UploadUniqueInput from '../../../components/model/business/forms/UploadUniqueInput';
import { DrawerPanelTitle, modalPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

const PortadaMassivePanel = ({
	selectedRowKeys,
	visible,
	onFinish,
	onCancel,
}: any) => {

	const [enabled, setEnabled] = useState('');
	const { t } = useTranslation();
	
	const onFormCancel = async (values: any) => {
		setEnabled('');
		onCancel();
	}

	return (
		<Modal
			open={visible}
			footer={null}
			onCancel={onFormCancel}
			width={'60%'}
			{...modalPanelStyles}
			title={
				<DrawerPanelTitle
					title={<><CameraOutlined/> {t('locals.page.management.modals.cover.title')}</>}
					locationsCount={selectedRowKeys.length}
					massive
				/>
			}
		>
			<div style={{marginTop:'20px'}}>
				<UploadUniqueInput
					selectedKeys={selectedRowKeys}
					onFinish={() => onFinish()}
					category="COVER"
					label={'Subir Portada'}
					textBtn={t('dictionary.apply')}
				/>
			</div>
		</Modal>
	)
}

export default PortadaMassivePanel;